import { createContext } from "react";

export const DataContext = createContext("");
export const PurchaseContext = createContext("");
export const TokenContext = createContext("");
